var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"times text-color-footer text-center text-uppercase auction-countdown",class:{ '-three' : _vm.skipDays }})}
var staticRenderFns = []

export { render, staticRenderFns }